import { ReactNode } from 'react';
import styled from 'styled-components';

interface FieldGroupProps {
  children?: ReactNode;
  name?: string;
}

export const FieldGroup = styled.div<FieldGroupProps>``;
